// Actions related to API calls for studies
import axios from "axios";
import { serverURL } from "../../constants/constants";
import { viewIds } from "../../constants/componentMap";

// Import necessary calls from other files
import {
  setView,
  errorResponse,
  warningResponse,
  setLocalFilepath,
} from "../../actions";
import { studyFixture } from "../../constants/Fixtures/studyFixture";

export function fetchLocalParticipantLog() {
  return function (dispatch, getState) {
    dispatch(requestLocalParticipantLog());
    let state = getState();
    let req;
    req = {
      credential: {
        username: state.userInfo.username,
        password: state.userInfo.password,
      },
    };
    console.log("POST request made for /get_local_participant_log", req);
    return axios.post(serverURL + "/get_local_participant_log", req).then(
      (response) => {
        dispatch(receiveLocalParticipantLog(response.data));
      },
      (error) => {
        dispatch(resetLocalParticipantLog());
        dispatch(errorResponse(error));
      }
    );
  };
}
export const REQUEST_LOCAL_PARTICIPANT_LOG = "REQUEST_LOCAL_PARTICIPANT_LOG";
export function requestLocalParticipantLog() {
  return {
    type: REQUEST_LOCAL_PARTICIPANT_LOG,
  };
}

export const RECEIVE_LOCAL_PARTICIPANT_LOG = "RECEIVE_LOCAL_PARTICIPANT_LOG";
export function receiveLocalParticipantLog(participantLog) {
  return {
    type: RECEIVE_LOCAL_PARTICIPANT_LOG,
    participantLog: participantLog,
  };
}
export const RESET_LOCAL_PARTICIPANT_LOG = "RESET_LOCAL_PARTICIPANT_LOG";
export function resetLocalParticipantLog() {
  return {
    type: RESET_LOCAL_PARTICIPANT_LOG,
  };
}

export function fetchRemoteParticipantLog() {
  return function (dispatch, getState) {
    console.log("GET request made for /get_remote_participant_log");
    dispatch(requestRemoteParticipantLog());
    return axios.get(serverURL + "/get_remote_participant_log").then(
      (response) => {
        dispatch(receiveRemoteParticipantLog(response.data));
      },
      (error) => {
        dispatch(resetRemoteParticipantLog());
        dispatch(errorResponse(error));
      }
    );
  };
}

export const REQUEST_REMOTE_PARTICIPANT_LOG = "REQUEST_REMOTE_PARTICIPANT_LOG";
export function requestRemoteParticipantLog() {
  return {
    type: REQUEST_REMOTE_PARTICIPANT_LOG,
  };
}

export const RECEIVE_REMOTE_PARTICIPANT_LOG = "RECEIVE_REMOTE_PARTICIPANT_LOG";
export function receiveRemoteParticipantLog(participantLog) {
  return {
    type: RECEIVE_REMOTE_PARTICIPANT_LOG,
    participantLog: participantLog,
  };
}

export const RESET_REMOTE_PARTICIPANT_LOG = "RESET_REMOTE_PARTICIPANT_LOG";
export function resetRemoteParticipantLog() {
  return {
    type: RESET_REMOTE_PARTICIPANT_LOG,
  };
}
export function fetchLocalParticipantsList() {
  return function (dispatch, getState) {
    dispatch(requestLocalParticipantsList());
    let state = getState();
    let req = {
      localFolderpath: state.availableStudies.localFolderpath,
      credential: {
        username: state.userInfo.username,
        password: state.userInfo.password,
      },
    };
    console.log("POST request made for /get_local_participants_list", req);
    return axios.post(serverURL + "/get_local_participants_list", req).then(
      (response) => {
        console.log("RECEIVED PARTICIPANTS", response.data);
        dispatch(
          receiveLocalParticipantsList(response.data["all_participants"])
        );
        dispatch(setLocalFilepath(response.data["local_folderpath"]));
      },
      (error) => {
        dispatch(resetLocalParticipantsList());
        dispatch(errorResponse(error));
      }
    );
  };
}

export const REQUEST_LOCAL_PARTICIPANTS_LIST =
  "REQUEST_LOCAL_PARTICIPANTS_LIST";
export function requestLocalParticipantsList() {
  return {
    type: REQUEST_LOCAL_PARTICIPANTS_LIST,
  };
}

export const RECEIVE_LOCAL_PARTICIPANTS_LIST =
  "RECEIVE_LOCAL_PARTICIPANTS_LIST";
export function receiveLocalParticipantsList(allParticipants) {
  return {
    type: RECEIVE_LOCAL_PARTICIPANTS_LIST,
    allParticipants: allParticipants,
  };
}
export const RESET_LOCAL_PARTICIPANTS_LIST = "RESET_LOCAL_PARTICIPANTS_LIST";
export function resetLocalParticipantsList() {
  return {
    type: RESET_LOCAL_PARTICIPANTS_LIST,
  };
}

export function fetchRemoteParticipantsList() {
  return function (dispatch, getState) {
    dispatch(requestRemoteParticipantsList());
    let state = getState();
    let req = {
      credential: {
        username: state.userInfo.username,
        password: state.userInfo.password,
      },
    };
    console.log("POST request made for /get_remote_participants_list", req);
    return axios.post(serverURL + "/get_remote_participants_list", req).then(
      (response) => {
        dispatch(
          receiveRemoteParticipantsList(response.data["all_participants"])
        );
      },
      (error) => {
        dispatch(resetRemoteParticipantsList());
        dispatch(errorResponse(error));
      }
    );
  };
}

export const REQUEST_REMOTE_PARTICIPANTS_LIST =
  "REQUEST_REMOTE_PARTICIPANTS_LIST";
export function requestRemoteParticipantsList() {
  return {
    type: REQUEST_REMOTE_PARTICIPANTS_LIST,
  };
}

export const RECEIVE_REMOTE_PARTICIPANTS_LIST =
  "RECEIVE_REMOTE_PARTICIPANTS_LIST";
export function receiveRemoteParticipantsList(allParticipants) {
  return {
    type: RECEIVE_REMOTE_PARTICIPANTS_LIST,
    allParticipants: allParticipants,
  };
}
export const RESET_REMOTE_PARTICIPANTS_LIST = "RESET_REMOTE_PARTICIPANTS_LIST";
export function resetRemoteParticipantsList() {
  return {
    type: RESET_REMOTE_PARTICIPANTS_LIST,
  };
}

export function fetchParticipantStudies(
  participantId,
  localStudies,
  remoteStudies
) {
  return function (dispatch, getState) {
    dispatch(requestParticipantStudies());
    let state = getState();
    // let req = {
    //   credential: {
    //     username: state.userInfo.username,
    //     password: state.userInfo.password,
    //   },
    //   localStudies: localStudies,
    //   remoteStudies: remoteStudies,
    // };
    // console.log("POST request made for /get_participant_studies/", req);
    // return axios.post(serverURL + "/get_participant_studies", req).then(
    //   (response) => {
    //     console.log("get_participant_studies", response);
    //     if (
    //       response.data.skipped_studies.length !==
    //       Object.keys(localStudies).length + remoteStudies.length
    //     ) {
    let data = {
      studies: {},
      savepath: "C:/Users/microelastic_user/Desktop/MicroElastic",
    };

    localStudies.forEach((studyId) => {
      console.log(studyId);

      if (studyId === studyFixture.study.studyInfo.id) {
        data.studies[studyId] = {
          ...studyFixture.study,
          protocol: studyFixture.protocol,
        };
      } else {
        data.studies[studyId] = {
          ...state.availableStudies.localStudyInfoById[studyId].study,
          protocol: state.availableStudies.localStudyInfoById[studyId].protocol,
        };
      }
    });

    dispatch(setSelectedParticipantId(participantId));
    dispatch(receiveParticipantStudies(data));
    dispatch(setView(viewIds.reviewMode));
    //       if (response.data.skipped_studies.length !== 0) {
    //         dispatch(
    //           warningResponse(
    //             `Failed to load study(s) ${response.data.skipped_studies}`
    //           )
    //         );
    //       }
    //     } else {
    //       dispatch(resetParticipantStudies());
    //       dispatch(errorResponse({ message: "Failed to load studies" }));
    //     }
    //   },
    //   (error) => {
    //     dispatch(resetParticipantStudies());
    //     dispatch(errorResponse(error));
    //   }
    // );
  };
}

export const REQUEST_PARTICIPANT_STUDIES = "REQUEST_PARTICIPANT_STUDIES";
export function requestParticipantStudies() {
  return {
    type: REQUEST_PARTICIPANT_STUDIES,
  };
}
export const RECEIVE_PARTICIPANT_STUDIES = "RECEIVE_PARTICIPANT_STUDIES";
export function receiveParticipantStudies(response) {
  return {
    type: RECEIVE_PARTICIPANT_STUDIES,
    studies: response.studies,
    savePath: response.savepath,
  };
}

export const RESET_PARTICIPANT_STUDIES = "RESET_PARTICIPANT_STUDIES";
export function resetParticipantStudies() {
  return {
    type: RESET_PARTICIPANT_STUDIES,
  };
}

export const SET_SELECTED_PARTICIPANT_ID = "SET_SELECTED_PARTICIPANT_ID";
export function setSelectedParticipantId(participantId) {
  return {
    type: SET_SELECTED_PARTICIPANT_ID,
    participantId,
  };
}
